import React from "react"

// A list read for a page past its last one: the API answers no rows with the whole filtered total, so the page is
// beyond the last page that total allows (never below page 1).
export const isPastLastPage = (page, { results, totalPages } = {}) =>
  !results?.length && Number(page) > Math.max(1, Number(totalPages) || 0)

// What an address or list-context directory shows on such a page instead of "No … match", as Organizers and Club
// leads do. The caller hides its pager and result range meanwhile, and its first-page action keeps the filters.
export default function PastLastPage({ onFirstPage }) {
  return <div role="status">
    <p>This page is no longer available.</p>
    <button type="button" className="btn btn-light" onClick={onFirstPage}>Go to first page</button>
  </div>
}
